import { motion } from "framer-motion";
import { ClipboardCheck, TrendingUp, Trophy } from "lucide-react";

const STEPS = [
  {
    icon: ClipboardCheck,
    no: "01",
    title: "Audit & Assess",
    desc: "We map your current training, nutrition, and recovery to expose exactly what's stalling your progress.",
  },
  {
    icon: TrendingUp,
    no: "02",
    title: "Progressive Overload",
    desc: "A periodised plan that forces adaptation week after week — engineered to push you past the plateau.",
  },
  {
    icon: Trophy,
    no: "03",
    title: "Peak Transformation",
    desc: "Dial in the details, sharpen your physique, and lock in habits that keep the gains coming for good.",
  },
];

export const Method = () => {
  return (
    <section
      id="method"
      data-testid="method-section"
      className="py-24 md:py-32 bg-[#0F0F0F] border-y border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl">
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-10 bg-[#E63946]" />
            <span className="text-xs uppercase tracking-[0.3em] text-neutral-400">
              The System
            </span>
          </div>
          <h2 className="font-heading font-black uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl">
            The Phase Forward Method
          </h2>
          <p className="mt-5 text-neutral-300 text-base lg:text-lg leading-relaxed">
            Three deliberate phases that turn a stalled lifter into a stronger,
            bigger version of himself.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.no}
              data-testid={`method-card-${i + 1}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="group bg-[#171717] border border-white/10 p-8 transition-all hover:-translate-y-1 hover:border-white/30"
            >
              <div className="flex items-center justify-between">
                <div className="h-12 w-12 flex items-center justify-center bg-[#E63946]/10 text-[#E63946] group-hover:bg-[#E63946] group-hover:text-white transition-colors">
                  <s.icon size={24} />
                </div>
                <span className="font-heading text-5xl font-black text-white/10">
                  {s.no}
                </span>
              </div>
              <h3 className="mt-7 font-heading text-2xl font-bold uppercase tracking-tight">
                {s.title}
              </h3>
              <p className="mt-3 text-neutral-400 leading-relaxed text-sm">
                {s.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
